define('OutSystems/ClientRuntime/SystemActions',["require", "exports", "tslib", "./DataTypes", "./Injector", "./Injector/KnownServices", "./Logger", "./Navigation", "./ScriptsManager"], function (require, exports, tslib_1, DataTypes, Injector_1, KnownServices_1, Logger, Navigation, ScriptsManager) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.setCurrentLocale = exports.logMessage = exports.requireScript = exports.listIndexOf = exports.listSort = exports.listFilter = exports.listAny = exports.listAll = exports.listDistinct = exports.listDuplicate = exports.listAppendAll = exports.listRemove = exports.listInsert = exports.listClear = exports.listAppend = void 0;
    var ListDuplicateOutputTypeFactory = new DataTypes.ComplexTypeKeyedTypeFactory("DuplicatedList", "duplicatedListOut");
    var ListFilterOutputTypeFactory = new DataTypes.ComplexTypeKeyedTypeFactory("FilteredList", "filteredListOut");
    var ListDistinctOutputTypeFactory = new DataTypes.ComplexTypeKeyedTypeFactory("DistinctList", "distinctListOut");
    var NullIterationContext = (function () {
        function NullIterationContext() {
        }
        NullIterationContext.prototype.getCurrentRowNumber = function (list) {
            return 0;
        };
        NullIterationContext.prototype.setCurrentRowNumber = function (list, newCurrentRowNumber) { };
        NullIterationContext.prototype.isBeingIterated = function (list) {
            return false;
        };
        NullIterationContext.prototype.registerIterationStart = function (list) { };
        NullIterationContext.prototype.registerIterationEnd = function (list) { };
        NullIterationContext.prototype.getIterator = function (list) {
            return null;
        };
        NullIterationContext.prototype.clone = function () {
            return this;
        };
        return NullIterationContext;
    }());
    function validateIterationState(list, iterationContext, opName) {
        if (iterationContext.isBeingIterated(list)) {
            throw new Error("List is being iterated: " + opName + " is not allowed");
        }
    }
    function wrapInIteration(list, iterationContext, operationName, body) {
        validateIterationState(list, iterationContext, operationName);
        try {
            iterationContext.registerIterationStart(list);
            return body();
        }
        finally {
            iterationContext.registerIterationEnd(list);
        }
    }
    function getIterationContextOrDefault(callContext) {
        if (callContext) {
            return callContext.iterationContext;
        }
        else {
            return new NullIterationContext();
        }
    }
    function listAppend(list, element, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        validateIterationState(list, iterationContext, "append");
        list.append(element);
    }
    exports.listAppend = listAppend;
    function listClear(list, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        validateIterationState(list, iterationContext, "clear");
        list.clear();
        iterationContext.setCurrentRowNumber(list, 0);
    }
    exports.listClear = listClear;
    function listInsert(list, element, position, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        validateIterationState(list, iterationContext, "insert");
        list.insert(position, element);
        var currentRowNumber = iterationContext.getCurrentRowNumber(list);
        if (list.length > 1 && position <= currentRowNumber) {
            iterationContext.setCurrentRowNumber(list, currentRowNumber + 1);
        }
    }
    exports.listInsert = listInsert;
    function listRemove(list, position, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        validateIterationState(list, iterationContext, "remove");
        list.remove(position);
        var currentRowNumber = iterationContext.getCurrentRowNumber(list);
        if (position < currentRowNumber) {
            iterationContext.setCurrentRowNumber(list, currentRowNumber - 1);
        }
        else if (position === list.length) {
            iterationContext.setCurrentRowNumber(list, Math.max(0, list.length - 1));
        }
    }
    exports.listRemove = listRemove;
    function listAppendAll(list, listToAppend, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        validateIterationState(list, iterationContext, "appendAll");
        list.appendAll(listToAppend);
    }
    exports.listAppendAll = listAppendAll;
    function listDuplicate(sourceList, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        validateIterationState(sourceList, iterationContext, "duplicate");
        var result = new (ListDuplicateOutputTypeFactory.getType(sourceList.constructor))();
        result.duplicatedListOut = sourceList.clone();
        return result;
    }
    exports.listDuplicate = listDuplicate;
    function listDistinct(sourceList, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        return wrapInIteration(sourceList, iterationContext, "distinct", function () {
            var result = new (ListDistinctOutputTypeFactory.getType(sourceList.constructor))();
            result.distinctListOut = sourceList.distinct();
            return result;
        });
    }
    exports.listDistinct = listDistinct;
    var ListOperationBooleanResultRecord = (function (_super) {
        tslib_1.__extends(ListOperationBooleanResultRecord, _super);
        function ListOperationBooleanResultRecord(defaults, cache) {
            return _super.call(this, defaults, cache) || this;
        }
        ListOperationBooleanResultRecord.attributesToDeclare = function () {
            return [
                this.attr("Result", "resultOut", "resultOut", true, true, DataTypes.DataTypes.Boolean, function () {
                    return;
                }),
            ].concat(_super.attributesToDeclare.call(this));
        };
        ListOperationBooleanResultRecord._constructor = (function () {
            ListOperationBooleanResultRecord.init();
        })();
        return ListOperationBooleanResultRecord;
    }(DataTypes.GenericRecord));
    function listAll(list, condition, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        return wrapInIteration(list, iterationContext, "all", function () {
            var result = new ListOperationBooleanResultRecord();
            result.resultOut = list.all(condition);
            return result;
        });
    }
    exports.listAll = listAll;
    function listAny(list, condition, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        return wrapInIteration(list, iterationContext, "any", function () {
            var result = new ListOperationBooleanResultRecord();
            result.resultOut = list.any(condition);
            return result;
        });
    }
    exports.listAny = listAny;
    function listFilter(list, condition, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        return wrapInIteration(list, iterationContext, "filter", function () {
            var result = new (ListFilterOutputTypeFactory.getType(list.constructor))();
            result.filteredListOut = list.filter(condition);
            return result;
        });
    }
    exports.listFilter = listFilter;
    function listSort(list, by, ascending, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        return wrapInIteration(list, iterationContext, "sort", function () {
            list.sort(by, ascending);
        });
    }
    exports.listSort = listSort;
    var ListOperationNumberResultRecord = (function (_super) {
        tslib_1.__extends(ListOperationNumberResultRecord, _super);
        function ListOperationNumberResultRecord(defaults, cache) {
            return _super.call(this, defaults, cache) || this;
        }
        ListOperationNumberResultRecord.attributesToDeclare = function () {
            return [
                this.attr("Position", "positionOut", "positionOut", true, true, DataTypes.DataTypes.Integer, function () {
                    return;
                }),
            ].concat(_super.attributesToDeclare.call(this));
        };
        ListOperationNumberResultRecord._constructor = (function () {
            ListOperationNumberResultRecord.init();
        })();
        return ListOperationNumberResultRecord;
    }(DataTypes.GenericRecord));
    function listIndexOf(list, condition, callContext) {
        var iterationContext = getIterationContextOrDefault(callContext);
        return wrapInIteration(list, iterationContext, "indexOf", function () {
            var result = new ListOperationNumberResultRecord();
            result.positionOut = list.indexOf(condition);
            return result;
        });
    }
    exports.listIndexOf = listIndexOf;
    function requireScript(scriptURL, callContext) {
        var versionedScriptURL = Navigation.VersionedURL.getVersionedUrl(scriptURL);
        return ScriptsManager.addScript(versionedScriptURL);
    }
    exports.requireScript = requireScript;
    function logMessage(message, moduleName, callContext) {
        Logger.log(moduleName, message);
    }
    exports.logMessage = logMessage;
    function setCurrentLocale(locale, callContext, injector) {
        if (injector === void 0) { injector = Injector_1.default; }
        var localeService = injector.resolve(KnownServices_1.ServiceNames.LocaleService);
        if (!localeService) {
            throw new Error("Undefined locale service: can't set current locale.");
        }
        localeService.setCurrentLocale(locale);
    }
    exports.setCurrentLocale = setCurrentLocale;
});
//# sourceMappingURL=SystemActions.js.map;
